export enum PropagationEnum {
    TEST_AND_TRAINING = "TEST_AND_TRAINING",
    LOCAL = "LOCAL",
    TRANSVERSE = "TRANSVERSE",
    NATIONAL = "NATIONAL"
}